// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const Payment = {
  "PAYED": "Payed",
  "RZI": "RZI",
  "MBAL": "MBAL",
  "NOT_PAYED": "NotPayed",
  "RAZLOG": "Razlog",
  "TUB": "TUB",
  "AUB": "AUB",
  "PIRIN": "PIRIN"
};

const TestType = {
  "QUICK_TEST": "QuickTest",
  "PCR": "Pcr"
};

const TestResult = {
  "POSITIVE": "Positive",
  "NEGATIVE": "Negative",
  "DOUBTFUL": "Doubtful",
  "IN_PROGRES": "InProgres"
};

const Sex = {
  "MALE": "Male",
  "FEMALE": "Female"
};

const { QuickPcr } = initSchema(schema);

export {
  QuickPcr,
  Payment,
  TestType,
  TestResult,
  Sex
};